import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'ArticleSportTable',
    props: {
        article: {
            default: () => ({}),
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS composables.
         */
        const css = useCssModule();
        const isGrouped = computed(() => (props.article?.rating || {}).grouped);
        const ratingComponent = computed(() => {
            if (isGrouped.value) {
                return () => import('~/components/ArticleRatingGroups/ArticleRatingGroups.vue');
            }
            return () => import('~/components/ArticleRating/ArticleRating.vue');
        });
        return {
            css,
            ratingComponent,
        };
    },
});
